// Buffs ativos (Haste, Magic Shield, posturas...) com o tempo que falta, acima da barra de ações.
import { useEffect, useState } from 'preact/hooks';
import { BUFFS } from '../../../../shared/src/game/buffs';
import { spellByWords } from '../spells';
import { SpellIcon } from './SpellIcon';

export function BuffBar(props: { list: Array<{ words: string; until: number }>; mshield: number; mshieldMax: number; xpBoostUntil?: number; xpBoostPct?: number }) {
  const [, tick] = useState(0);
  useEffect(() => { const t = setInterval(() => tick((x) => x + 1), 500); return () => clearInterval(t); }, []);
  const now = Date.now();
  const boost = (props.xpBoostUntil ?? 0) > now ? Math.ceil((props.xpBoostUntil! - now) / 1000) : 0;
  if (!props.list.length && !boost) return null;
  const fmt = (s: number) => s >= 3600 ? `${Math.floor(s / 3600)}h${String(Math.floor(s % 3600 / 60)).padStart(2, '0')}` : s >= 60 ? `${Math.floor(s / 60)}m` : `${s}s`;
  return (
    <div class="buffbar">
      {boost > 0 && (
        <span class="buff buff-xp" title={`Bônus de experiência: +${props.xpBoostPct ?? 50}% de XP. Faltam ${fmt(boost)} (${Math.ceil(boost / 60)} min).`}>
          <b>+{props.xpBoostPct ?? 50}%<br />XP</b>
          <small>{fmt(boost)}</small>
        </span>
      )}
      {props.list.map((b) => {
        const def = BUFFS[b.words];
        const sp = spellByWords(b.words);
        const left = b.until ? Math.max(0, Math.ceil((b.until - now) / 1000)) : null;
        return (
          <span key={b.words} class="buff" title={`${def?.name ?? b.words}: ${def?.desc ?? ''}`}>
            {sp ? <SpellIcon spell={sp} size={22} /> : <b>{def?.name?.[0]}</b>}
            <small>{left === null ? '∞' : left >= 60 ? `${Math.floor(left / 60)}m` : `${left}s`}</small>
            {def?.magicShield && props.mshieldMax > 0 && (
              <i class="buff-shield"><i style={{ width: `${Math.round(props.mshield / props.mshieldMax * 100)}%` }} /></i>
            )}
          </span>
        );
      })}
    </div>
  );
}
